import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';
import { MidYearEvaluation } from './_interfaces/mid-year-evaluation.interface';
import { ProcessTypeEnum } from 'src/app/shared/interfaces/process.interface';

@Injectable()
export class FreeEvaluationService {

    constructor(private _httpService: BackendService) {
    }

    public getMidYearEvaluations(cycleId: number): Observable<any> {
        return this._httpService.get('getMidYearEvaluations', [], [
            { 'name': 'cycleId', 'value': cycleId as any }
        ]);
    }

    public getUsersForEvaluation(
            cycleId: number, searchString: string = ''
    ): Observable<any> {
        return this._httpService.get('getUsersForEvaluation', [], [
            { 'name': 'cycleId', 'value': cycleId as any },
            { 'name': 'searchString', 'value': searchString }
        ]);
    }

    public saveMidYearEvaluation(evaluation: MidYearEvaluation): Observable<any> {
        return this._httpService.post('saveMidYearEvaluation', evaluation);
    }

    public updateMidYearEvaluation(evaluation: MidYearEvaluation): Observable<any> {
        return this._httpService.put('updateMidYearEvaluation', evaluation);
    }

    public deleteMidYearEvaluation(evaluationId: number): Observable<any> {
        return this._httpService.delete('deleteMidYearEvaluation', [
            { 'name': 'id', 'value': evaluationId as any }
        ]);
    }

    public sendMidYearEvaluations(
            cycleParticipantId: number, evaluationsIds: Array<number>, dateNow: string, localReopeningStepEndDate: string
    ): Observable<any> {
        return this._httpService.post('sendMidYearEvaluations', {
            'ids': evaluationsIds,
            'cycleParticipantId': cycleParticipantId,
            'dateNow': dateNow,
            'localReopeningStepEndDate': localReopeningStepEndDate
        });
    }

    public reopenUserStepEvaluation(
            processType: ProcessTypeEnum, cycleParticipantId: number, cycleProcessConfigId: number, closed: Boolean
    ): Observable<any> {
        return this._httpService.post('midYearMoveUser', {
            'cycleParticipantId': cycleParticipantId,
            'processType': processType,
            'cycleProcessConfigId': cycleProcessConfigId,
            'closed': closed
        });
    }

    public reopenMidYearEvaluation(
            cycleParticipantId: number,
            userId: string
    ): Observable<any> {
        return this._httpService.post('reopenFreeMidYearEvaluation', {
            'cycleId': cycleParticipantId,
            'subjectUserId': userId
        });
    }

}
